import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const FlexibleModels = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/dedicated-dev-2.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Flexible Models: Hire Developers on a Monthly, Hourly, or Project-Based Arrangement</h1>
                  <h2 id="sub_heading1">
                  In today’s fast-paced digital world, businesses need flexible and scalable hiring solutions to meet their evolving software development needs. Whether you are a startup looking to launch your MVP or an enterprise needing ongoing development support, choosing the right hiring model can significantly impact your project's success.Flexible hiring models allow businesses to hire expert developers based on their specific requirements. You can choose from monthly, hourly, or project-based hiring arrangements to optimize costs, efficiency, and project timelines. Let’s explore each model in detail and help you decide which is the best fit for your business.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
                <h3>What is<span>Monthly Hiring ?</span></h3>
                <p>Monthly hiring involves hiring developers on a full-time or part-time basis for an agreed duration, typically on a rolling month-to-month contract. Businesses that require dedicated attention from developers for ongoing projects or software maintenance often prefer this model.</p>
                <h4>Advantages of Monthly Hiring:</h4>
                <ul>
                    <li><strong>Dedicated Focus:</strong> Developers work exclusively on your project, ensuring consistency and quality.</li>
                    <li><strong>Scalability:</strong> Easily scale up or down based on project needs.</li>
                    <li><strong>Cost-Effective:</strong> More affordable than hiring an in-house development team.</li>
                    <li><strong>Seamless Communication:</strong> Ongoing collaboration and direct communication with the developers.</li>
                </ul>
                <h4>Ideal Use Cases:</h4>
                <ul>
 	<li>Large-scale software development projects</li>
 	<li>SaaS product development and maintenance</li>
 	<li>Enterprise solutions requiring continuous updates and support</li>
</ul>
                <h3>Hourly<span> Hiring Model</span></h3>
                <p>Best For: Small tasks, short-term projects, and ongoing maintenance</p>
                <h4>What is Hourly Hiring?</h4>
                <p>Hourly hiring allows businesses to pay developers based on the hours worked. This model is ideal for companies that need expert assistance for specific tasks, bug fixes, or periodic maintenance.</p>
                <h4>Advantages of Hourly Hiring:</h4>
                <ul>
                    <li><strong>Flexible Work Hours:</strong> Pay only for the time spent on development.</li>
                    <li><strong>No Long-Term Commitment:</strong> Ideal for businesses with irregular workloads.</li>
                    <li><strong>Quick Turnaround:</strong> Get developers to work on urgent fixes or enhancements without delays.</li>
                    <li><strong>Budget-Friendly:</strong> Helps control development costs for minor or short-term tasks.</li>
                </ul>
                <h4>Ideal Use Cases:</h4>
                <ul>
 	<li>Bug fixes and software troubleshooting</li>
 	<li>Adding new features to existing applications</li>
 	<li>UI/UX improvements and enhancements</li>
 	<li>Performance optimization of web and mobile applications</li>
</ul>
            <h3>Project-Based <span>Hiring Model</span></h3>
            <p>Best For: Well-defined projects with fixed scope, budget, and timeline</p>
            <h4>What is Project-Based Hiring?</h4>
            <p>Project-based hiring is a fixed-cost arrangement where developers are hired for a specific project with a clear scope, timeline, and deliverables. Businesses prefer this model when they need a complete solution without ongoing maintenance or post-launch modifications.</p>
            <h4>Advantages of Project-Based Hiring:</h4>
            <ul>
 	<li><strong>Fixed Cost:</strong> Know your total investment upfront.</li>
 	<li><strong>Defined Timeline:</strong> Projects are delivered within agreed deadlines.</li>
 	<li><strong>Reduced Management Effort:</strong> The development team handles all aspects of the project.</li>
 	<li><strong>Best for One-Time Projects:</strong> Ideal for businesses that do not require continuous development.</li>
</ul>
<h4>Ideal Use Cases:</h4>
<ul>
 	<li>Building a Minimum Viable Product (MVP)</li>
 	<li>Website or mobile app development</li>
 	<li>Custom software solutions</li>
 	<li>System migrations or upgrades</li>
</ul>
<h4>How to Choose the Right Hiring Model?</h4>
<p>The choice of hiring model depends on several factors, including project complexity, budget, timeline, and business goals. Each model offers different levels of flexibility and cost efficiency, making it important to evaluate your specific needs before making a decision.</p>
<h3><span>Conclusion</span></h3>
<p>Choosing the right hiring model can have a significant impact on your business’s software development process. Whether you need full-time developers for ongoing projects, hourly developers for quick fixes, or a dedicated team for a one-time project, flexible hiring options offer the right balance of cost, expertise, and scalability.At CodeFlix, we provide top-tier developers tailored to your project needs. Contact us today to find the best hiring solution for your business and take your development efforts to the next level!</p>

            </div>
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default FlexibleModels;
